import request from '@lib/request'

// 试卷列表
function GetList({
  keyword,
  teacherId,
  start,
  rows
}) {
  return request
    .get('/institutionAdmin/hopeEvaluation/list', {
      params: {
        keyword,
        teacher_id: teacherId,
        start,
        rows
      }
    })
    .then(result => result.data)
}

// 获取试卷配置（题型/教材/严格度，编辑场景回填）
function GetConfigInfo({ hopeEvaluationId } = {}) {
  return request
    .get('/institutionAdmin/hopeEvaluation/getConfigInfo', {
      params: {
        hope_evaluation_id: hopeEvaluationId
      }
    })
    .then(result => result.data)
}

// 生成新试卷预览（不入库）
function GetNewEvaluationData({
  teacherId,
  evaluationName,
  evaluationTotalTime,
  scoreElasticity,
  selectInfo,
  hopeEvaluationId
}) {
  const form = new FormData()
  form.append('teacher_id', teacherId)
  form.append('evaluation_name', evaluationName)
  form.append('evaluation_total_time', evaluationTotalTime)
  if (scoreElasticity !== undefined && scoreElasticity !== null) {
    form.append('score_elasticity', scoreElasticity)
  }
  form.append('select_info', JSON.stringify(selectInfo || []))
  if (hopeEvaluationId) {
    form.append('hope_evaluation_id', hopeEvaluationId)
  }
  return request
    .post('/institutionAdmin/hopeEvaluation/getNewEvaluationData', form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(response => response.data)
}

// 单题换题
function ChangeQuestion({
  selectInfo,
  currentQuestionId,
  historyId
}) {
  const form = new FormData()
  form.append('select_info', JSON.stringify(selectInfo || []))
  form.append('current_question_id', currentQuestionId)
  if (historyId) {
    form.append('history_id', historyId)
  }
  return request
    .post('/institutionAdmin/hopeEvaluation/changeQuestion', form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(response => response.data)
}

// 保存试卷（新建 / 更新）
function SaveEvaluation({
  teacherId,
  evaluationName,
  evaluationTotalTime,
  scoreElasticity,
  selectInfo,
  saveInfo,
  hopeEvaluationId,
  isManual,
  isShowReport
}) {
  const form = new FormData()
  form.append('teacher_id', teacherId)
  form.append('evaluation_name', evaluationName)
  form.append('evaluation_total_time', evaluationTotalTime)
  if (scoreElasticity !== undefined && scoreElasticity !== null) {
    form.append('score_elasticity', scoreElasticity)
  }
  form.append('select_info', JSON.stringify(selectInfo || []))
  form.append('save_info', JSON.stringify(saveInfo || []))
  if (isManual !== undefined && isManual !== null) {
    form.append('is_manual', isManual)
  }
  if (isShowReport !== undefined && isShowReport !== null) {
    form.append('is_show_report', isShowReport)
  }
  if (hopeEvaluationId) {
    form.append('hope_evaluation_id', hopeEvaluationId)
  }
  return request
    .post('/institutionAdmin/hopeEvaluation/saveEvaluation', form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(response => response.data)
}

// 复制试卷
function CopyEvaluation({ hopeEvaluationId, teacherId }) {
  return request
    .get('/institutionAdmin/hopeEvaluation/copyEvaluation', {
      params: {
        hope_evaluation_id: hopeEvaluationId,
        teacher_id: teacherId
      }
    })
    .then(result => result.data)
}

// 预览试卷
function GetPreviewEvaluationData({ hopeEvaluationId }) {
  return request
    .get('/institutionAdmin/hopeEvaluation/getPreviewEvaluationData', {
      params: {
        hope_evaluation_id: hopeEvaluationId
      }
    })
    .then(result => result.data)
}

// 下发弹窗 - 老师名下班级列表
function GroupListForSend({ teacherId, keyword, start, rows }) {
  return request
    .get('/institutionAdmin/hopeEvaluation/groupListForSend', {
      params: {
        teacher_id: teacherId,
        keyword,
        start,
        rows
      }
    })
    .then(result => result.data)
}

// 下发到班级(每班独立时间)
function SendToGroups({ hopeEvaluationId, items }) {
  const form = new FormData()
  form.append('hope_evaluation_id', hopeEvaluationId)
  form.append('items', JSON.stringify(items || []))
  return request
    .post('/institutionAdmin/hopeEvaluation/sendToGroups', form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(response => response.data)
}

// 撤回下发
function CancelSend({ sendId }) {
  const form = new FormData()
  form.append('send_id', sendId)
  return request
    .post('/institutionAdmin/hopeEvaluation/cancelSend', form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(response => response.data)
}

// 报告页 - 班级筛选下拉(同时用于撤回弹窗取 send_id)
function SendGroupListForReport({ hopeEvaluationId }) {
  return request
    .get('/institutionAdmin/hopeEvaluation/sendGroupListForReport', {
      params: {
        hope_evaluation_id: hopeEvaluationId
      }
    })
    .then(result => result.data)
}

// 报告主体 - 学生成绩列表
function ReportGroupSummary({ hopeEvaluationId, groupId, start, rows }) {
  const params = {
    hope_evaluation_id: hopeEvaluationId,
    start,
    rows
  }
  if (groupId) {
    params.group_id = groupId
  }
  return request
    .get('/institutionAdmin/hopeEvaluation/reportGroupSummary', { params })
    .then(result => result.data)
}

// 报告详情 - 学生题目级明细
function ReportStudentDetail({ recordId }) {
  return request
    .get('/institutionAdmin/hopeEvaluation/reportStudentDetail', {
      params: {
        record_id: recordId
      }
    })
    .then(result => result.data)
}

export default {
  GetList,
  GetConfigInfo,
  GetNewEvaluationData,
  ChangeQuestion,
  SaveEvaluation,
  CopyEvaluation,
  GetPreviewEvaluationData,
  GroupListForSend,
  SendToGroups,
  CancelSend,
  SendGroupListForReport,
  ReportGroupSummary,
  ReportStudentDetail
}
